module.exports = __webpack_public_path__ + "img/dianli.ec610828.png";